import React from 'react';
import { Label } from '../Label';
export const CashbackLabel = ({ type, withIcon }) => (React.createElement(Label, { textColor: "red800", backgroundColor: "red100", letterSpacing: "normal", borderRadius: "2px", padding: "medium", iconSize: "12px", lineHeight: "normal", textTransform: "none", icon: withIcon ? 'Boost' : undefined },
    "20",
    type === 'e' ? '€' : '%',
    " de cashback"));
